export const SEND_MFA_CODE_REQUEST = 'SEND_MFA_CODE_REQUEST';
export const SEND_MFA_CODE_SUCCESS = 'SEND_MFA_CODE_SUCCESS';
export const SEND_MFA_CODE_FAILURE = 'SEND_MFA_CODE_FAILURE';

export const CONFIRM_MFA_CODE_REQUEST = 'CONFIRM_MFA_CODE_REQUEST';
export const CONFIRM_MFA_CODE_SUCCESS = 'CONFIRM_MFA_CODE_SUCCESS';
export const CONFIRM_MFA_CODE_FAILURE = 'CONFIRM_MFA_CODE_FAILURE';

export const BACK_LOGIN = 'BACK_LOGIN';
